export const types: string[] = [
  'Default',
  'Promotional',
  'Welcome',
  'Newsletter',
  'Feedback Request',
  'Follow-Up',
  'Event Invitation',
  'Thank You',
];

export const tones = [
  'Default',
  'Funny',
  'Sad',
  'Nostalgic',
  'Angry',
  'Empathetic',
  'Sarcastic',
];
